const roundDecimalPoint = (value: number, base: number) => {
  const pow = Math.pow(10, base);
  return Math.round(value * pow) / pow;
};

export default roundDecimalPoint;
